import { FeedbackMessageSurveyProps } from '@/components/FeedbackMessageSurvey/useViewModel'
import { useAppDispatch } from '@/hooks'
import { submitContactFormWithAuth } from '@/actions/form'
import FeedbackMessageSurvey from '../FeedbackMessageSurvey'

type FeedbackMessageSurveyWithContactFormProps = {
  supportTitle: string
  feedbackExtra?: string
} & FeedbackMessageSurveyProps

/** wrapper for feedbackMessageSurvey that also submits a ticket to support */
export default function FeedbackMessageSurveyWithContactForm(
  props: FeedbackMessageSurveyWithContactFormProps,
) {
  const dispatch = useAppDispatch()
  const { supportTitle, feedbackExtra, onSubmit, ...passedProps } = props
  const submitContactForm = ({
    message,
    reason,
  }: {
    message: string
    reason: string
  }) => {
    dispatch(
      submitContactFormWithAuth({
        title: props.supportTitle,
        message: `Reason: ${reason},
            Message: ${message},
            ${props.feedbackExtra ? `Extra: ${props.feedbackExtra}` : ''}`,
      }),
    )
  }

  return (
    <FeedbackMessageSurvey
      {...passedProps}
      onSubmit={({ message, reason }) => {
        submitContactForm({
          message,
          reason,
        })
        onSubmit({ message, reason })
      }}
    />
  )
}
